import withAemIntegration from "../../../withAemIntegration";
//import Component from '@lexus/ui/dist/components/BaseStoryModule';

const InfoLayerEditConfig = {
  emptyLabel: "Infolayer Feature",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

//const transformData = (props) => ({
//    component: 'InfoLayer',
//    props: {
//        ...props,
//        stories: props.stories.map(story => ({
//            ...story,
//            height: (window && window.CQ) ? '600px' : undefined,
//        })),
//    }
//});

const InfoLayer = (props) => {
  //const data = transformData(props);
  return (
    //<Component {...data.props} />
    <div>
      <div>Feature ID: {props.itemId}</div>
      <div>Feature Override: {props.heading}</div>
    </div>
  );
};

export default withAemIntegration(
  "lexus/components/infolayer/infolayer-feature-tooltip"
)(InfoLayer, InfoLayerEditConfig);
